export interface CustomerBonus {
  amountIntervals: AmountInterval[];
  cashierConfiguration: CashierConfiguration;
  id: string;
  fastSumsType?: FastSumsType;
  intervalsType?: IntervalsType;
}

export const FastSumsTypes = {
  Amount: 'amount',
  Percent: 'percent',
} as const;

export type FastSumsType = (typeof FastSumsTypes)[keyof typeof FastSumsTypes];

export const IntervalsTypes = {
  Reward: 'reward',
  DepositRange: 'depositRange',
} as const;

export type IntervalsType =
  (typeof IntervalsTypes)[keyof typeof IntervalsTypes];

export const RewardTypes = {
  Fractional: 'fractional',
  Fixed: 'fixed',
  UnCountable: 'unCountable',
} as const;

type RewardTypeKeys = (typeof RewardTypes)[keyof typeof RewardTypes];

export interface AmountInterval {
  rewardType: RewardTypeKeys;
  reward: {
    from: number | null;
    to: number | null;
  };
  depositRange?: {
    from: number | null;
    to: number | null;
  };
  attributes: {
    measurement: string;
    volume?: number | null;
    fraction?: number | null;
  };
  description: {
    params: {
      formula?: string;
    };
    pattern: string;
  };
  title: {
    params: {
      formula?: string;
    };
    pattern: string;
  };
}

interface CashierConfiguration {
  displayBonusCalculator: boolean;
  displayBonusFastSums: boolean;
  iconURL: string;
}

export interface TaxConfiguration {
  taxPercentage: string;
  deductibleStake: string;
}
